import React, {Component} from "react"
import PropTypes from "prop-types"
import {isEmpty} from "lodash"

import Expand from "@irati/ui/src/Expander"
import {Label2} from "@irati/ui/src/Labels"
import getCurrency from "@irati/deals/helpers/deals/currency"
import {injectIntl, FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import OrderWrapper from "./styled/OrderWrapper"
import OrderDetails from "./OrderDetails"
import TotalLabel from "./styled/TotalLabel"

class OrderSummary extends Component {
  constructor() {
    super()
    this.expand = null
  }
  StickyComponent = () => {
    if (!isEmpty(this.expand) && this.expand.state.isOpen) {
      return null
    }
    const {order, deal} = this.props
    return (
      <TotalLabel className="pull-right">
        {(order.total.value > 0) ?
          <FormattedCurrency isCents={false} currency={getCurrency(deal)} value={order.total.value} /> :
          <FormattedMessage id="perks.components.dealSuccessOrderSummary.orderSummary.free" />}
      </TotalLabel>
    )
  }

  render() {
    const {order, deal, formatMessage} = this.props
    return (
      <OrderWrapper>
        <Expand
          ref={(el) => { this.expand = el }}
          HeaderLabel={Label2}
          showText={formatMessage({id: "perks.components.dealSuccessOrderSummary.orderSummary.expand"})}>
          <OrderDetails order={order} deal={deal} currency={getCurrency(deal)} />
        </Expand>
      </OrderWrapper>)
  }
}

OrderSummary.defaultProps = {
  order: null,
  deal: null
}
OrderSummary.propTypes = {
  order: PropTypes.object,
  deal: PropTypes.object,
  formatMessage: PropTypes.func.isRequired
}

export default injectIntl(OrderSummary)
